import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { Dispatch, memo, ReactNode, SetStateAction } from 'react';

type Props = {
  setIsDialogOpen: Dispatch<SetStateAction<boolean>>; // Open/Closeの状態設定
  handleOk: () => void; // OKボタン押下時処理
  dialogContents: string | ReactNode; // 表示内容
};

/**
 * 確認ダイアログ
 * @param Props props
 * @returns ConfirmDialog
 */
export const ConfirmDialog = memo(({ setIsDialogOpen, handleOk, dialogContents }: Props) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setIsDialogOpen(false);
  };
  const handleConfirmClick = () => {
    handleOk();
    setIsDialogOpen(false);
  };
  return (
    <Dialog open onClose={handleClose} aria-describedby="alert-dialog-description" fullWidth data-testid="modal">
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{dialogContents}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={handleClose}>
          {t('button.cancel')}
        </Button>
        <Button color="primary" variant="contained" onClick={handleConfirmClick}>
          {t('button.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
